import React, { useEffect } from 'react';
import { Hero } from './components/webinars/Hero';
import { WebinarBrowser } from './components/webinars/WebinarBrowser';
function useNoIndex() {
  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow, noarchive, nosnippet';
    document.head.appendChild(meta);
    const previousTitle = document.title;
    document.title = 'BOSS Webinar Registration Centre';
    return () => {
      meta.remove();
      document.title = previousTitle;
    };
  }, []);
}
export function App() {
  useNoIndex();
  return <div className="w-full min-h-full bg-background font-heading text-foreground antialiased" data-id="element-0" data-mp="31b8l22qjqjbb">
      <a href="#webinars" className="sr-only rounded-full bg-brand px-5 py-2.5 text-[15px] font-semibold text-white focus:not-sr-only focus:absolute focus:left-6 focus:top-6 focus:z-50" data-id="element-1" data-mp="2wjgqzi86lvgf">
        Skip to webinars
      </a>
      <main data-id="element-2" data-mp="23utadzydnu97">
        <Hero data-id="element-3" data-mp="23t8i6gzjcnei" />
        <WebinarBrowser data-id="element-4" data-mp="23ti5fwt74ggi" />
      </main>
    </div>;
}